import React from 'react';
import { Table, Card, Tag, Alert } from 'antd';
import styles from './Mount.module.scss';

const MountInfo = ({ fstabInfo, mountInfo }) => {
  // fstab 정보 파싱
  const parseFstabInfo = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const entries = [];
      const lines = data.trim().split('\n');
      
      lines.forEach(line => {
        // 주석 및 빈 줄 건너뛰기
        if (line.startsWith('#') || !line.trim()) return;
        
        const parts = line.trim().split(/\s+/);
        if (parts.length >= 6) {
          entries.push({
            device: parts[0],
            mountPoint: parts[1],
            fsType: parts[2],
            options: parts[3],
            dump: parts[4],
            fsck: parts[5],
            key: `${parts[0]}-${parts[1]}`
          });
        }
      });
      
      return entries;
    } catch (error) {
      console.error('Error parsing fstab info:', error);
      return [];
    }
  };
  
  // 마운트 정보 파싱
  const parseMountInfo = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const entries = [];
      const lines = data.trim().split('\n');
      
      lines.forEach(line => {
        const parts = line.trim().split(/\s+/);
        if (parts.length >= 3) {
          entries.push({
            device: parts[0],
            mountPoint: parts[2],
            fsType: parts[4],
            options: parts.slice(5).join(' ').replace(/[()]/g, ''),
            key: `${parts[0]}-${parts[2]}`
          });
        }
      });
      
      return entries;
    } catch (error) {
      console.error('Error parsing mount info:', error);
      return [];
    }
  };

  const fstabEntries = parseFstabInfo(fstabInfo);
  const mountEntries = parseMountInfo(mountInfo);
  
  // fstab에 있지만 마운트되지 않은 항목 찾기
  const unmountedEntries = fstabEntries.filter(fstabEntry => 
    !mountEntries.some(mountEntry => 
      mountEntry.mountPoint === fstabEntry.mountPoint
    )
  );

  return (
    <Card title="마운트 정보" className={styles.mountCard}>
      {unmountedEntries.length > 0 && (
        <Alert
          message="마운트되지 않은 항목 발견"
          description={`fstab에 정의되었지만 마운트되지 않은 항목이 ${unmountedEntries.length}개 있습니다.`}
          type="warning"
          showIcon
          className={styles.alertBox}
        />
      )}
      
      <h3>fstab 설정</h3>
      <Table 
        dataSource={fstabEntries}
        rowKey="key"
        pagination={false}
        columns={[
          { title: '장치', dataIndex: 'device', key: 'device' },
          { title: '마운트 포인트', dataIndex: 'mountPoint', key: 'mountPoint' },
          { title: '파일시스템', dataIndex: 'fsType', key: 'fsType' },
          { title: '옵션', dataIndex: 'options', key: 'options' },
          { title: '덤프', dataIndex: 'dump', key: 'dump' },
          { title: 'fsck', dataIndex: 'fsck', key: 'fsck' },
          { 
            title: '상태', 
            key: 'status',
            render: (_, record) => {
              const isMounted = mountEntries.some(entry => entry.mountPoint === record.mountPoint);
              return isMounted ? 
                <Tag color="green">마운트됨</Tag> : 
                <Tag color="red">마운트되지 않음</Tag>;
            }
          }
        ]}
      />
      
      <h3 className={styles.sectionTitle}>현재 마운트 상태</h3>
      <Table 
        dataSource={mountEntries}
        rowKey="key"
        pagination={false}
        columns={[
          { title: '장치', dataIndex: 'device', key: 'device' },
          { title: '마운트 포인트', dataIndex: 'mountPoint', key: 'mountPoint' },
          { title: '파일시스템', dataIndex: 'fsType', key: 'fsType' },
          { title: '옵션', dataIndex: 'options', key: 'options' },
          { 
            title: 'fstab 설정', 
            key: 'fstab',
            render: (_, record) => {
              const inFstab = fstabEntries.some(entry => entry.mountPoint === record.mountPoint);
              return inFstab ? 
                <Tag color="green">fstab에 있음</Tag> : 
                <Tag color="orange">동적 마운트</Tag>;
            }
          }
        ]}
      />
    </Card>
  );
};

export default MountInfo;